module.exports = __webpack_public_path__ + "img/banner6.fe55de0e.png";